"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _ResponsiveModal = _interopRequireDefault(require("../../ResponsiveModal"));
var _HeaderMenuCategory = _interopRequireWildcard(require("../HeaderMenuCategory"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ITEMS = [{
  title: _localization.i18n.t('headerMenu.profile'),
  link: '/client'
}, {
  title: _localization.i18n.t('headerMenu.logout'),
  link: '/logout'
}];
var HeaderMenuProfile = function HeaderMenuProfile(props) {
  var name = props.name,
    slug = props.slug,
    showPopup = props.showPopup,
    onOpenModal = props.onOpenModal,
    onCloseModal = props.onCloseModal,
    IconComponent = props.IconComponent,
    shouldShowCloseIcon = props.shouldShowCloseIcon,
    PopupAuthComponent = props.PopupAuthComponent,
    isLoggedIn = props.isLoggedIn,
    isCompact = props.isCompact,
    breakpoint = props.breakpoint,
    className = props.className,
    isWhitelabel = props.isWhitelabel,
    isHomepage = props.isHomepage;
  var hasLoggedIn = isLoggedIn ? {
    items: ITEMS,
    IconComponent: IconComponent
  } : {
    onClick: onOpenModal
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CategoryProfile, (0, _extends2["default"])({
    name: name,
    isWhiteLabel: isWhitelabel,
    slug: slug,
    isCompact: isCompact,
    $isLoggedIn: isLoggedIn,
    $isWhitelabel: isWhitelabel,
    className: className,
    breakpoint: breakpoint
  }, hasLoggedIn, {
    isHomepage: isHomepage,
    "data-testid": "HEADER_USERNAME_TEST_ID"
  })), /*#__PURE__*/_react["default"].createElement(_ResponsiveModal["default"], {
    open: showPopup,
    onClose: onCloseModal,
    showCloseIcon: shouldShowCloseIcon
  }, PopupAuthComponent));
};
var CategoryProfile = (0, _styledComponents["default"])(_HeaderMenuCategory["default"]).withConfig({
  displayName: "HeaderMenuProfile__CategoryProfile",
  componentId: "sc-1dh79un-0"
})(["width:", ";", " ", " ", "{text-align:right;}"], function (_ref) {
  var $isLoggedIn = _ref.$isLoggedIn,
    isCompact = _ref.isCompact;
  return $isLoggedIn && isCompact && 'auto';
}, function (_ref2) {
  var $isLoggedIn = _ref2.$isLoggedIn,
    $isWhitelabel = _ref2.$isWhitelabel;
  return $isLoggedIn && !$isWhitelabel && "@media screen and (max-width: 1250px) {\n    width: 80px;\n}";
}, function (_ref3) {
  var items = _ref3.items;
  return !items && "\n    cursor: pointer;\n  ";
}, _HeaderMenuCategory.NestedMenu);
var _default = exports["default"] = HeaderMenuProfile;